/**
 * Custom JavaScript for MebleFurniture.com
 * Cleaned up: Removed deprecated mutation events, console.logs, and optimized resize handlers
 */

jQuery(document).ready(function($) {
  // Use MutationObserver instead of deprecated DOMNodeInserted/DOMNodeRemoved
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.className && node.className.indexOf('mfp-wrap') !== -1) {
            var heightT = window.innerHeight;
            setTimeout(function() {
              $('body').css({
                'overflow': 'hidden',
                'overflow-y': 'hidden',
                'height': heightT + 'px'
              });
            }, 500);
          }
        });
        mutation.removedNodes.forEach(function(node) {
          if (node.className && node.className.indexOf('mfp-bg') !== -1 && 
              node.className.indexOf('mfp-removing') !== -1) {
            $('body').css('overflow-y', 'auto');
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: false
    });
  }

  // Debounced resize handler for height tracking
  var initial = window.innerHeight;
  var resizeTimeout;
  
  $(window).on('resize.customHeight', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      var currentHeight = window.innerHeight;
      if (currentHeight > initial) {
        $('body').addClass('wc-height-increased');
      } else {
        $('body').removeClass('wc-height-increased');
      }
    }, 100);
  });

  // Tab functionality
  $('.first-tab-active').addClass('active');
  $(document).on('click', '.info-tabs .open-bio', function() {
    $('.first-tab-active').removeClass('active');
    $('.open-bio').removeClass('first-tab-active');
    $(document).find('.bio-more').removeClass('active-description-tab');
  });

  // Move search form on mobile
  if (window.innerWidth <= 1200) {
    $('#header > form').appendTo('#header > .header_bot');
  }

  // FIX: Force Stamped rating to stay big after widget loads
  function fixStampedRatingSize() {
    // Try multiple possible selectors - including the strong tag inside
    var selectors = [
      '.stamped-summary-text-1',
      '.stamped-summary-text-1 strong',
      '.stamped-summary-text-1 > strong',
      '#stamped-main-widget .stamped-summary-text-1',
      '#stamped-main-widget .stamped-summary-text-1 strong',
      '.summary-rating-num',
      '.stamped-summary-text span:first-child',
      '[data-widget-style] .stamped-summary-text-1',
      '.stamped-summary .stamped-summary-text > span:first-child'
    ];
    
    selectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) {
        el.style.setProperty('font-size', '24px', 'important');
        el.style.setProperty('font-weight', '700', 'important');
        el.style.setProperty('color', '#111', 'important');
        el.style.setProperty('line-height', '1.1', 'important');
      });
    });
  }
  
  // Run repeatedly to catch Stamped's async rendering
  var fixIntervals = [500, 1000, 1500, 2000, 2500, 3000, 4000, 5000];
  fixIntervals.forEach(function(ms) {
    setTimeout(fixStampedRatingSize, ms);
  });
  
  // Also run on any DOM changes within Stamped widget
  var stampedObserver = new MutationObserver(function() {
    fixStampedRatingSize();
  });
  
  function startObservingStamped() {
    var widget = document.getElementById('stamped-main-widget');
    if (widget) {
      stampedObserver.observe(widget, { childList: true, subtree: true, attributes: true });
      fixStampedRatingSize();
    } else {
      setTimeout(startObservingStamped, 500);
    }
  }
  startObservingStamped();
});
